import { TextStyle } from '@tiptap/extension-text-style';

// `@tiptap/extension-text-style@3.x`'s `removeEmptyTextStyle` strips the `textStyle`
// mark far outside the selection, so clearing a font colour or a highlight on a few characters
// wiped the colour off the whole table.

const hasAnyAttributeSet = (mark) => Object.values(mark.attrs).some((value) => Boolean(value));

export const SelectionScopedTextStyle = TextStyle.extend({
  addCommands() {
    return {
      ...this.parent(),

      removeEmptyTextStyle:
        () =>
        ({ tr }) => {
          // Snapshot before the walk. `removeMark` never changes the document's size, so these
          // positions stay valid for the whole pass.
          const { ranges } = tr.selection;

          ranges.forEach(({ $from, $to }) => {
            const from = $from.pos;
            const to = $to.pos;

            tr.doc.nodesBetween(from, to, (node, pos) => {
              if (node.isTextblock) {
                return true;
              }

              const textStyle = node.marks.find((mark) => mark.type === this.type);

              // No mark on this node means nothing of ours to strip. Removing it anyway would
              // reach every descendant, which is the whole bug.
              if (!textStyle || hasAnyAttributeSet(textStyle)) {
                return true;
              }

              tr.removeMark(Math.max(pos, from), Math.min(pos + node.nodeSize, to), this.type);

              return true;
            });
          });

          return true;
        }
    };
  }
});

export default SelectionScopedTextStyle;
